module.exports = __webpack_public_path__ + "static/compass-ec497fa666c0ea545bbee12439a3918e.svg";